<template>
  <div class="signer-tool space-y-1" @click="openModal">
    <font-awesome-icon :icon="['fas', 'pen-fancy']" class="h-4 w-4" />
    <p>TTE</p>
  </div>
  <dialog
    ref="tteModal"
    class="modal fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    @click.self="closeModal"
  >
    <div
      class="modal-box bg-white p-6 rounded-lg flex flex-col gap-5 shadow-xl max-w-md relative"
      @click.stop
    >
      <h1 class="text-2xl font-bold text-gray-800 mb-5">
        Pilih Tanda Tangan Elektronik
      </h1>

      <div class="grid grid-flow-row gap-2">
        <div
          v-for="tool in tools"
          :key="tool.name"
          class="signer-tool border flex items-center space-x-4 cursor-pointer hover:bg-gray-100 rounded-lg transition duration-200 ease-in-out py-5 px-4"
          :tool="tool.tool"
          :action="tool.action"
          @click="handleToolClick(tool)"
        >
          <div class="flex items-center space-x-4">
            <font-awesome-icon
              :icon="['fas', 'pen-fancy']"
              :class="tool.iconClass"
            />
            <p class="text-base">{{ tool.name }}</p>
          </div>
        </div>
      </div>
      <div class="modal-action">
        <form method="dialog">
          <button class="btn">Tutup</button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const tteModal = ref(null);

    const tools = [
      {
        name: "TTE Pangkat Pendek",
        tool: "e-signature-short",
        action: true,
        iconClass: "h-4 w-4 text-blue-500",
      },
      {
        name: "TTE Pangkat Panjang",
        tool: "e-signature-long",
        action: true,
        iconClass: "h-4 w-4 text-green-500",
      },
      {
        name: "TTE Pangkat Pendek Penyesuaian Nama",
        tool: "e-signature-wrapShort",
        action: true,
        iconClass: "h-4 w-4 text-red-500",
      },
      {
        name: "TTE Pangkat Panjang Penyesuaian Nama",
        tool: "e-signature-wrapLong",
        action: true,
        iconClass: "h-4 w-4 text-purple-500",
      },
    ];

    const openModal = () => {
      if (tteModal.value) {
        tteModal.value.showModal();
        tteModal.value.querySelector("button").focus();
      }
    };

    const closeModal = () => {
      if (tteModal.value) {
        tteModal.value.close();
      }
    };

    const handleToolClick = (tool) => {
      if (tool.action) {
        console.log(`Tool action triggered for: ${tool.name}`);
      }
      closeModal();
    };

    return {
      tteModal,
      tools,
      openModal,
      closeModal,
      handleToolClick,
    };
  },
};
</script>

<style scoped>
/* Modal backdrop styling using Tailwind classes */
.modal {
  z-index: 9999; /* Ensures modal is on top */
}

/* Additional styling for the modal box */
.modal-box {
  overflow-y: auto; /* Enable scrolling if content exceeds height */
}
</style>
